{
  "welcome": {
    "title": "Conversaciones de Sabiduría",
    "subtitle": "Elige un compañero IA para comenzar un diálogo significativo.\nCada uno aporta una perspectiva única a tu camino.",
    "startConversation": "Iniciar Conversación"
  },
  "companions": {
    "aiGuide": "Guía IA",
    "whatCanYouAsk": "¿Qué puedes preguntar?"
  },
  "sidebar": {
    "title": "Chats",
    "aiCompanions": "Compañeros IA",
    "masters": "Maestros",
    "friends": "Personas",
    "circles": "Círculos",
    "recentChats": "CHATS RECIENTES",
    "personal": "PERSONAL",
    "notepad": "Tu bloc de notas personal",
    "online": "En línea",
    "startConversation": "Iniciar una conversación",
    "new": "Nuevo",
    "youPrefix": "Tú: ",
    "you": "Tú",
    "unreadA11y_one": "{{count}} mensaje sin leer",
    "unreadA11y_many": "{{count}} mensajes sin leer",
    "unreadA11y_other": "{{count}} mensajes sin leer",
    "messagesTitle": "Mensajes",
    "messagesSubtitle": "Conversaciones privadas",
    "searchA11y": "Buscar conversaciones",
    "yesterday": "Ayer"
  },
  "chat": {
    "unnamedUser": "Usuario",
    "messagePlaceholder": "Tu mensaje…",
    "receiptRead": "Leído",
    "receiptSent": "Enviado",
    "send": "Enviar",
    "sendHint": "Enter para enviar, Shift + Enter para una nueva línea",
    "placeholder": "Escribe una nota...",
    "masterPlaceholder": "Mensaje a {{name}}...",
    "friendPlaceholder": "Mensaje a {{name}}...",
    "master": "Maestro",
    "savedMessages": "Mensajes Guardados",
    "notesStored": "Las notas se almacenan localmente en este dispositivo.",
    "messagesDelivered": "Los mensajes se entregan directamente al maestro.",
    "aiDisclaimer": "Las respuestas de IA son generadas y pueden no ser siempre precisas. Para emergencias, contacta a un profesional.",
    "demoDisclaimer": "Modo demo — las respuestas son simuladas.",
    "jotDown": "Anota ideas para sesiones, recordatorios o cualquier cosa que quieras guardar para después.",
    "startWith": "Inicia una conversación con {{name}}. Pregunta sobre sus prácticas, horarios o guía espiritual.",
    "demoBadge": "DEMO · MENSAJERÍA REAL PRÓXIMAMENTE",
    "typing": {
      "someone": "alguien",
      "one": "{{name}} está escribiendo…",
      "two": "{{name1}} y {{name2}} están escribiendo…",
      "many": "{{count}} personas están escribiendo…"
    },
    "date": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "unreadDivider": "Mensajes nuevos"
    },
    "empty": {
      "channel": {
        "title": "Aquí hay silencio",
        "description": "Envía el primer mensaje — da vida al círculo"
      },
      "message": {
        "title": "Aún no hay mensajes",
        "description": "Sé el primero en iniciar la conversación"
      },
      "thread": {
        "title": "La discusión aún está vacía",
        "description": "Responde para desarrollar la idea"
      },
      "pinned": {
        "title": "Nada fijado aún",
        "description": "Fija mensajes importantes para encontrarlos fácilmente"
      }
    },
    "pinned": {
      "label": "Fijado",
      "fullTitle": "Mensaje fijado",
      "readMore": "Leer más",
      "unpin": "Quitar fijación",
      "limitToast": "Ya hay un mensaje fijado. Quita la fijación para fijar otro."
    },
    "bounce": {
      "title": "Mensaje retenido",
      "description": "Tu mensaje incluye algo que la comunidad maneja con cuidado. Reformúlalo e inténtalo de nuevo.",
      "editAndSend": "Editar y enviar",
      "sendAnyway": "Enviar igual",
      "delete": "Eliminar",
      "editingTitle": "Edita y vuelve a enviar",
      "editPlaceholder": "Reformula tu mensaje…",
      "send": "Enviar",
      "sending": "Enviando…",
      "cancel": "Cancelar"
    },
    "voiceBlocked": {
      "title": "Mensaje de voz no enviado",
      "description": "Parece que este mensaje de voz tiene palabras que la comunidad maneja con cuidado. Graba uno nuevo e inténtalo de nuevo.",
      "ok": "Entendido"
    },
    "aboutEvent": "Sobre la sesión en vivo",
    "archiveNotice": "La sesión en vivo ha terminado. Estos son los mensajes de su chat.",
    "byMaster": "Presenta {{name}}",
    "customAmount": "Otra cantidad",
    "defaultDescription": "Una sesión en vivo con {{name}}: ven a estar aquí juntos.",
    "disconnected": "Conexión perdida",
    "firstMessage": "Aquí todavía hay silencio",
    "host": "Presenta",
    "liveSession": "Sesión en vivo",
    "offering": "Apoyar",
    "reconnecting": "Reconectando…",
    "sayHello": "Saluda a la comunidad",
    "thankYou": "Gracias por tu apoyo: {{amount}}",
    "time": {
      "now": "ahora mismo",
      "minutesAgo": "hace {{count}} min"
    },
    "fragment": {
      "ask": "Preguntar sobre esto",
      "askAboutPhrase": "Preguntar sobre una frase",
      "pickTitle": "Selecciona una frase",
      "pickHint": "Selecciona la parte del mensaje sobre la que quieres preguntar.",
      "cancel": "Cancelar",
      "originalDeleted": "El mensaje original fue eliminado"
    }
  },
  "categories": {
    "ai": "IA",
    "masters": "Maestros",
    "friends": "Amigos",
    "circles": "Círculos"
  },
  "wisdomCouncil": {
    "title": "Consejo de Sabiduría",
    "subtitle": "Pregunta a los sabios",
    "description": "Haz preguntas al consejo. Usa @menciones para dirigirte a sabios específicos.",
    "members": "Miembros del consejo",
    "starredMessages": "Mensajes destacados",
    "starredEmpty": "Marca mensajes con estrella para guardar sabiduría",
    "starMessage": "⭐ Destacar",
    "unstarMessage": "★ Quitar",
    "tabs": {
      "answer": "Respuesta",
      "links": "Enlaces",
      "media": "Medios"
    },
    "devDayMinutes": "1 día ="
  },
  "sidebarEmpty": {
    "noResults": "Sin resultados",
    "noContacts": "Aún no hay contactos",
    "createTestCircle": "Crear círculo de prueba",
    "devOnlyHint": "solo dev • para probar Eventos"
  },
  "authGate": {
    "title": "Inicia sesión para acceder a los chats",
    "description": "Inicia sesión para conversar con compañeros IA, maestros, amigos y círculos.",
    "logIn": "Iniciar sesión",
    "noAccount": "¿No tienes cuenta? Regístrate"
  },
  "moderation": {
    "unmute": "Quitar silenciar",
    "mute": "Silenciar",
    "kick": "Expulsar del círculo",
    "ban": "Banear permanentemente",
    "kickConfirmTitle": "Expulsar del círculo",
    "kickConfirmBody": "¿Seguro que quieres expulsar a {{name}}? Perderá acceso al chat y a los eventos del círculo.",
    "kickWorking": "Expulsando…",
    "kickConfirm": "Expulsar",
    "banConfirmTitle": "Banear permanentemente",
    "banConfirmBody": "{{name}} nunca podrá volver al círculo. ¿Confirmas?",
    "banWorking": "Baneando…",
    "banConfirm": "Banear",
    "mutePickerTitle": "Silenciar a {{name}}",
    "mutePickerBody": "No podrá escribir, pero seguirá en el círculo y verá el contenido",
    "muteDurations": {
      "h1": "1 hora",
      "h24": "24 horas",
      "d7": "7 días",
      "forever": "Para siempre"
    },
    "cancel": "Cancelar"
  },
  "native": {
    "subtitle": "Habla con maestros, amigos y el consejo de sabiduría",
    "searchPlaceholder": "Buscar en los mensajes",
    "tabs": {
      "all": "Todos",
      "ai": "IA",
      "people": "Personas"
    },
    "empty": "Aún no hay conversaciones",
    "aiSection": "Compañeros de IA",
    "peopleSection": "Personas",
    "aiFriend": "Amigo de IA",
    "peer": "Contacto",
    "draft": "Borrador: ",
    "thread": {
      "voiceFailed": "El mensaje de voz no se envió",
      "voiceFailBody": "Sin conexión con el chat. La grabación está guardada — puedes enviarla de nuevo.",
      "voiceRetry": "Reintentar",
      "voiceDiscard": "Eliminar"
    }
  },
  "agapellaSubscriptionOffer": {
    "button": "Obtener la suscripción Agapēlla"
  },
  "tour": {
    "replayCta": "Hacer el recorrido por la plataforma",
    "replayAgain": "Repetir el recorrido por la plataforma"
  },
  "preview": {
    "attachment": {
      "voiceRecording": "Mensaje de voz",
      "image": "Foto",
      "video": "Vídeo",
      "audio": "Audio",
      "giphy": "GIF",
      "file": "Archivo adjunto"
    }
  },
  "thread": {
    "opening": "Abriendo la conversación…"
  },
  "emptyDialog": {
    "title": "Más cerca unos de otros",
    "subtitle": "Elige una conversación a la izquierda para continuar",
    "circlesTitle": "Círculos",
    "circlesSubtitle": "Elige un círculo para abrir su conversación."
  },
  "aiNotice": {
    "caption": "Las respuestas las genera la IA",
    "link": "Aviso sobre IA (en ruso)"
  },
  "aiConsentDeclined": {
    "title": "De acuerdo, sin la asistente de IA",
    "body": "Sin tu consentimiento, el chat con Agapella permanece cerrado y no se envía nada al servicio de IA. El resto de la plataforma funciona con normalidad. Si cambias de opinión, puedes volver a leer las condiciones.",
    "readAgain": "Volver a leer las condiciones"
  }
}
